module.exports = __webpack_public_path__ + "static/img/6.fe28f96.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/6.png
// module id = 1Ztr
// module chunks = 0